<template>
  <div>
    <v-row>
      <v-col
        cols="12"
        md="4"
      >
        <v-card outlined>
          <v-card-text>
            Customer Information
            <v-simple-table dense>
              <template v-slot:default>
                <tbody>
                  <tr>
                    <th class="text-left">
                      Full Name
                    </th>
                    <td>{{ customer.firstName }} {{ customer.lastName }}</td>
                  </tr>
                  <tr>
                    <th class="text-left">
                      Gender
                    </th>
                    <td>{{ customer.gender }}</td>
                  </tr>

                  <tr>
                    <th class="text-left">
                      Date Of Birth
                    </th>
                    <td>{{ customer.dateOfBirth }}</td>
                  </tr>
                  <tr>
                    <th class="text-left">
                      Identification
                    </th>
                    <td>{{ customer.identification }}</td>
                  </tr>

                  <tr>
                    <th class="text-left">
                      Tax Id
                    </th>
                    <td>
                      {{ customer.taxId }}
                    </td>
                  </tr>
                  <tr>
                    <th class="text-left">
                      Address
                    </th>
                    <td>
                      {{ customer.address }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        md="8"
      >
        <v-card outlined>
          <v-card-text>
            <v-btn @click="$router.back()">
              Back
            </v-btn>
          </v-card-text>
          <v-card-text>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">
                      Method
                    </th>
                    <th class="text-left">
                      Gateway
                    </th>
                    <th class="text-left">
                      Amount
                    </th>
                    <th class="text-left">
                      Status
                    </th>
                    <th class="text-left">
                      More
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="item in payments"
                    :key="item.name"
                  >
                    <td>{{ item.method ? "Debit" : "Credit" }}</td>
                    <td>{{ item.gateway }}</td>
                    <td>{{ item.amount | currency }}</td>
                    <td>{{ item.status ? "Paid" : "Pending" }}</td>
                    <td>
                      <router-link
                        :to="{
                          name: 'PaymentDetails',
                          params: { id: item.id },
                        }"
                      >
                        #payment
                      </router-link>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      customer: {},
      payments: {},
    };
  },
  mounted() {
    if (this.$route.params.id) {
      window.axios
        .get("/customer/" + this.$route.params.id)
        .then((response) => {
          this.$data.customer = response.data.customer;
          this.$data.payments = response.data.customer.payments;
        });
    }
  },
};
</script>
